import React from "react";
import insurance from "../assets/images/insurance.webp";

const TransferSection = () => {
  return (
    <section
      className="md:scroll-mt-52 relative w-full overflow-hidden bg-cover bg-center bg-no-repeat max-w-7xl mx-auto rounded-lg md:px-0 px-4 md:pb-6"
      style={{
        // backgroundImage: `url(${transferbg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      {/* Left white fade */}
      <div className="absolute inset-0 z-0 bg-gradient-to-r from-white via-white/90 via-[18%] to-transparent"></div>

      <div className="relative z-10  flex flex-wrap items-center py-12 ">
        <div className="xl:w-6/12 ">
          {/* Small heading */}
          <div className="mb-5 flex items-center gap-3 ">
            {/* <span className="h-[2px] w-7 bg-[#78bd2b]"></span> */}
            <span className=" inline-block text-base font-bold tracking-[0.2em] text-sky-800">
              Airport & City Transfers
            </span>
          </div>

          {/* Heading */}
          <h1 className="m-0 text-[25px] font-bold leading-[1.05] tracking-[-0.2px] text-[#12344A] sm:text-[48px] lg:text-[58px]">
            Smooth, Reliable &
            <br />
            <span className="text-[#10233b]">Comfortable Rides</span>
          </h1>

          {/* Description */}
          <p className="mt-5 max-w-[570px] text-[14px] leading-[1.55] text-[#536B7A] sm:text-[15px] lg:text-[16px]">
            We offer state-of-the-art transfer services for both airport
            pick-ups/drop-offs and intercity travel. Whether you’re arriving
            after a long flight or moving between destinations, our professional
            drivers ensure a safe, comfortable, and timely journey.
          </p>

          {/* Features */}
          <div className="mt-5 mb-6 flex flex-col gap-3 sm:flex-row sm:gap-10 lg:gap-16">
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="flex h-[50px] w-[50px] shrink-0 items-center justify-center rounded-full bg-[#e0f4ff] text-[#1595d0]">
                  <i className="text-[28px] las la-plane" />
                </div>
                <span className="text-[13px] font-semibold text-[#263b55] sm:text-[16px]">
                  Airport Transfers
                </span>
              </div>

              <div className="flex items-center gap-3">
                <div className="flex h-[50px] w-[50px] shrink-0 items-center justify-center rounded-full bg-[#e8f8d9] text-[#76bd2d]">
                  <i className="text-[28px] las la-user" />
                </div>
                <span className="text-[13px] font-semibold text-[#263b55] sm:text-[16px]">
                  Professional Drivers
                </span>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="flex h-[50px] w-[50px] shrink-0 items-center justify-center rounded-full bg-[#e8f8d9] text-[#76bd2d]">
                  <i className="text-[28px] las la-car" />
                </div>
                <span className="text-[13px] font-semibold text-[#263b55] sm:text-[16px]">
                  Intercity Transfers
                </span>
              </div>

              <div className="flex items-center gap-3">
                <div className="flex h-[50px] w-[50px] shrink-0 items-center justify-center rounded-full bg-[#e0f4ff] text-[#1595d0]">
                  <i className="text-[28px] las la-shield-alt" />
                </div>
                <span className="text-[13px] font-semibold text-[#263b55] sm:text-[16px]">
                  Modern Fleet
                </span>
              </div>
            </div>
          </div>

          {/* Actions */}
          {/* <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center">
            <button className="flex h-12 items-center justify-center gap-4 rounded-lg border-0 bg-gradient-to-r from-[#82bd28] to-[#65a91f] px-6 text-[14px] font-semibold text-white shadow-[0_7px_18px_rgba(104,169,31,0.22)] transition duration-200 hover:-translate-y-0.5 hover:shadow-[0_10px_22px_rgba(104,169,31,0.30)]">
              Book Your Transfer
              <i className="text-[12px] las la-arrow-right" />
            </button>

            <div className="flex h-12 w-[290px] overflow-hidden rounded-[9px] border border-[#d7e9f2] bg-white/95 shadow-[0_4px_14px_rgba(35,108,140,0.12)]">
              <div className="flex h-full items-center gap-1.5 border-r border-[#e6edf2] px-2.5 text-[13px] font-medium text-[#34495e]">
                <span className="text-[16px]">🇮🇳</span>
                <span>+91</span>
                <span className="text-[#8998a5]">⌄</span>
              </div>

              <input
                type="text"
                placeholder="Enter Mobile Number"
                className="min-w-0 flex-1 border-0 bg-transparent px-2.5 text-[13px] text-[#334155] outline-none placeholder:text-[#9aa7b4]"
              />

              <button className="m-[5px] flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-full border-0 bg-[#168dc4] text-white transition hover:bg-[#087aad]">
                <i className="text-[12px] las la-arrow-right" />
              </button>
            </div>
          </div> */}
        </div>

        <div className="xl:w-6/12 flex justify-end">
          <img src={insurance} className="md:h-[580px] rounded-lg" />
        </div>
      </div>
    </section>
  );
};

export default TransferSection;
